import React, { Component } from "react";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//icons
import { FiPlus } from "react-icons/fi";
import stages from "../../../../images/icon/stages.png";

import "../../../../styles/Tournaments.css";
import TournamentHeader from "../common/TournamentHeader";
import { IoInformationCircleOutline } from "react-icons/io5";
import {
  errorHandler,
  getMatchesStructure,
  getTournamentData,
  getWebData,
  is_Natural,
  PlayoffFormats,
} from "../../../../utils/common.utils";
import TournamentApis from "../../../../helper/tournament.api";
import { toast } from "react-toastify";

import { AiFillDelete, AiOutlineCheck } from "react-icons/ai";
import { Modal } from "react-bootstrap";
import ConfirmationModal from "../../../popup/ConfirmationModal";
import { isPrime } from "../../../../utils/Validations";
import { WARNING, LABEL, PLACEHOLDER } from "../../../../utils/Strings.utils";
import ReactTooltip from "react-tooltip";
import { BsInfoCircle } from "react-icons/bs";

export default class FBracketGroups extends Component {
  constructor(props) {
    super(props);
    const queryParams = new URLSearchParams(window.location.search);
    let localData = JSON.parse(localStorage.getItem("ffa-bracket-groups"));

    this.state = {
      tournamentDetails: null,
      openConfirmationModal: false,
      openEditConfirmationModal: false,
      stageName:
        !queryParams.get("isUpdate") &&
        localData?.stageName &&
        localData?.tournamentId === props.match.params.id
          ? localData.stageName
          : "",
      maxParticipants:
        !queryParams.get("isUpdate") &&
        localData?.maxParticipants &&
        localData?.tournamentId === props.match.params.id
          ? localData.maxParticipants
          : "",
      noOfGroup:
        !queryParams.get("isUpdate") &&
        localData?.noOfGroup &&
        localData?.tournamentId === props.match.params.id
          ? localData.noOfGroup
          : "",
      participantPerMatch:
        !queryParams.get("isUpdate") &&
        localData?.participantPerMatch &&
        localData?.tournamentId === props.match.params.id
          ? localData.participantPerMatch
          : "",
      winnerPerMatch:
        !queryParams.get("isUpdate") &&
        localData?.winnerPerMatch &&
        localData?.tournamentId === props.match.params.id
          ? localData.winnerPerMatch
          : "",
      threshold:
        !queryParams.get("isUpdate") &&
        localData?.threshold &&
        localData?.tournamentId === props.match.params.id
          ? localData.threshold
          : "",
      updatedMatches: false,
      minParticipant: null,
      playoffFormat:
        !queryParams.get("isUpdate") &&
        localData?.playoffFormat &&
        localData?.tournamentId === props.match.params.id
          ? localData.playoffFormat
          : 1,
    };
    this.localObject = {
      stageName:
        !queryParams.get("isUpdate") &&
        localData?.stageName &&
        localData?.tournamentId === props.match.params.id
          ? localData.stageName
          : "",
      maxParticipants:
        !queryParams.get("isUpdate") &&
        localData?.maxParticipants &&
        localData?.tournamentId === props.match.params.id
          ? localData.maxParticipants
          : "",
      noOfGroup:
        !queryParams.get("isUpdate") &&
        localData?.noOfGroup &&
        localData?.tournamentId === props.match.params.id
          ? localData.noOfGroup
          : "",
      participantPerMatch:
        !queryParams.get("isUpdate") &&
        localData?.participantPerMatch &&
        localData?.tournamentId === props.match.params.id
          ? localData.participantPerMatch
          : "",
      winnerPerMatch:
        !queryParams.get("isUpdate") &&
        localData?.winnerPerMatch &&
        localData?.tournamentId === props.match.params.id
          ? localData.winnerPerMatch
          : "",
      threshold:
        !queryParams.get("isUpdate") &&
        localData?.threshold &&
        localData?.tournamentId === props.match.params.id
          ? localData.threshold
          : "",
      playoffFormat:
        !queryParams.get("isUpdate") &&
        localData?.playoffFormat &&
        localData?.tournamentId === props.match.params.id
          ? localData.playoffFormat
          : 1,
      tournamentId: this.props.match.params.id,
    };
    this.props.updateLoader(true);
    getTournamentData(this.props.match.params.id, this.setData);

    this.tournament = new TournamentApis();

    this.isUpdate = queryParams.get("isUpdate");
    this.index = queryParams.get("index");
    this.editIsUpdate = false;
    this.editStages = [];
    this.isValuesChanged = false;
    this.currentStages = null;
  }

  componentDidMount() {
    this.props.showOrHideNav(true);
  }

  // when data not came from location.state it returns data from API
  setData = values => {
    if (values) {
      this.setState({
        tournamentDetails: values,
        maxParticipants: values.stages[this.index]?.maxParticipants
          ? values.stages[this.index]?.maxParticipants
          : this.state.maxParticipants,
        noOfGroup: values.stages[this.index]?.maxNumberOfGroups
          ? values.stages[this.index]?.maxNumberOfGroups
          : this.state.noOfGroup,
        participantPerMatch: values.stages[this.index]?.maxParticipantsPerMatch
          ? values.stages[this.index]?.maxParticipantsPerMatch
          : this.state.participantPerMatch,
        winnerPerMatch: values.stages[this.index]?.winnersPerMatch
          ? values.stages[this.index]?.winnersPerMatch
          : this.state.winnerPerMatch,
        threshold: values.stages[this.index]?.qualificationThreshold
          ? values.stages[this.index]?.qualificationThreshold
          : this.state.threshold,
        stageName: values.stages[this.index]?.name
          ? values.stages[this.index]?.name
          : this.state.stageName,
        playoffFormat: values.stages[this.index]?.playoffFormat
          ? values.stages[this.index].playoffFormat
          : this.state.playoffFormat,
        minParticipant: values?.stages?.length
          ? values?.stages[
              values?.stages?.length > 1 && this.isUpdate
                ? values?.stages?.length - 2
                : values?.stages?.length - 1
            ].qualificationThreshold
          : null,
      });
      this.props.updateLoader(false);
    } else {
      this.props.updateLoader(false);
      this.props.history.push("/pageNotFound");
    }
  };

  onSubmit = values => {
    var isUpdate;
    if (this.isUpdate === null) {
      isUpdate = false;
    } else {
      isUpdate = true;
    }

    var stage = {
      level: isUpdate
        ? this.currentStages[this.index].level
        : this.state.tournamentDetails?.stages?.length + 1,
      name: values.stageName,
      type: "FFA",
      subType: "FFA Bracket Groups",
      path: "ffa-bracket-groups",
      status: "UPCOMING",
      maxParticipants: parseInt(values.maxParticipant),
      maxNumberOfGroups: parseInt(values.maxNumberOfGroups),
      maxParticipantsPerGroup: parseInt(values.maxParticipant) / parseInt(values.maxNumberOfGroups),
      maxParticipantsPerMatch: parseInt(values.maxParticipantsPerMatch),
      winnersPerMatch: parseInt(values.winnersPerMatch),
      qualificationThreshold: parseInt(values.qualificationThreshold),
      playoffFormat: values.playoffFormat ? parseInt(values.playoffFormat) : 1,
    };

    if (isUpdate && !this.state.updatedMatches) {
      stage.groups = this.currentStages[this.index].groups;
    } else {
      stage.groups = getMatchesStructure(stage, 7);
    }

    this.editIsUpdate = isUpdate;
    this.editStages = [stage];
    let previousStageData = this.state.tournamentDetails?.stages[this.index];
    if (isUpdate) {
      if (
        previousStageData.name !== values.stageName ||
        previousStageData.maxParticipants !== values.maxParticipant ||
        previousStageData.maxNumberOfGroups !== values.maxNumberOfGroups ||
        previousStageData.maxParticipantsPerGroup !== stage.maxParticipantsPerGroup ||
        previousStageData.maxParticipantsPerMatch !== values.maxParticipantsPerMatch ||
        previousStageData.winnersPerMatch !== stage.winnersPerMatch ||
        previousStageData.qualificationThreshold !== stage.qualificationThreshold ||
        previousStageData.playoffFormat !== stage.playoffFormat
      ) {
        this.isValuesChanged = true;
      }
    }

    if (
      isUpdate &&
      parseInt(this.index) !== parseInt(this.state.tournamentDetails?.stages.length - 1) &&
      this.isValuesChanged
    ) {
      this.setState({ openEditConfirmationModal: true });
    } else {
      this.addOrUpdate([stage], isUpdate);
    }
  };

  addOrUpdate = (stages, isUpdate) => {
    if (this.state.tournamentDetails?.participantUserId?.length && this.isUpdate) {
      toast.error("Cannot update the stage after participants added in tournament");
    } else {
      this.props.updateLoader(true);
      this.tournament
        .addOrUpdateStage(this.props.match?.params?.id, stages, isUpdate)
        .then(res => {
          this.props.updateLoader(false);
          if (isUpdate) {
            this.props.history.push(
              `/organization/${res.data.result.organizationId}/tournament/${res.data.result._id}/overview/structure`
            );
            toast.success(`Stage updated successfully`);
          } else {
            localStorage.removeItem("ffa-bracket-groups");
            var index =
              this.state.tournamentDetails?.stages?.length === 0
                ? 0
                : this.state.tournamentDetails?.stages?.length;
            this.props.history.push(
              `/organization/${res.data.result.organizationId}/tournament/${res.data.result._id}/overview/structure/tournament-stages/${index}/slot-details/0`
            );
            toast.success(`Stage created successfully`);
          }
        })
        .catch(reason => {
          this.props.updateLoader(false);
          errorHandler(reason);
        });
    }
  };

  deleteStage = index => {
    var data = {
      tournamentId: this.props.match?.params?.id,
      stage: index,
    };
    // var stages = this.state.tournamentDetails.stages;
    // stages.splice(index, 1);
    // this.update(stages,"deleted");
    this.props.updateLoader(true);
    this.tournament
      .deleteStage(data)
      .then(res => {
        this.props.updateLoader(false);
        this.props.history.push({
          pathname: `/organization/${res.data.result.organizationId}/tournament/${res.data.result._id}/overview/structure`,
          state: {
            orgId: res.data.result.organizationId,
            tournamentDetails: res.data.result,
          },
        });
        toast.success(`Stage ${parseInt(index) + 1} deleted successfully`);
      })
      .catch(reason => {
        this.props.updateLoader(false);
        errorHandler(reason);
      });
  };

  //open confirmation popup
  onClickOpenConfirm = () => {
    this.setState({
      openConfirmationModal: !this.state.openConfirmationModal,
    });
  };

  updateQuantity = (e, key) => {
    e.preventDefault();
    if (!this.isUpdate) {
      this.localObject[key] = e.target.value;
      localStorage.setItem("ffa-bracket-groups", JSON.stringify(this.localObject));
    }
    this.setState({
      [key]: e.target.value,
      updatedMatches: true,
    });
  };
  maxParticipantVal = val => {
    let error;
    let number = parseFloat(val);
    if (!is_Natural(number)) {
      error = `Invalid input value`;
    } else if (isPrime(number)) {
      error = `Max participants should not be a prime number`;
    } else if (number > this.state.tournamentDetails?.maxParticipant) {
      error = `Max participants cannot be more than ${this.state.tournamentDetails?.maxParticipant}`;
    }
    if (this.index !== "0") {
      if (number < this.state.minParticipant) {
        error = `Max participants should not be less than ${this.state.minParticipant}`;
      }
    }
    return error;
  };
  noOfGroupVal = val => {
    let error;
    let number = parseFloat(val);
    if (this.state.maxParticipants && val) {
      if (!is_Natural(number)) {
        error = `Invalid input value`;
      } else if (this.state.maxParticipants % number !== 0) {
        error = `Group number should be divisor of ${this.state.maxParticipants}`;
      }
    }
    return error;
  };
  participantPerMatchVal = val => {
    let error;
    let number = parseFloat(val);
    if (this.state.maxParticipants && this.state.noOfGroup && val) {
      if (!is_Natural(number)) {
        error = `Invalid input value`;
      } else if (number < 3) {
        error = `Participant per match should be more than 2`;
      } else if ((this.state.maxParticipants / this.state.noOfGroup) % val !== 0) {
        error = `Participant per match should be divisor of ${this.state.maxParticipants / this.state.noOfGroup}`;
      }
    }
    return error;
  };
  winnerPerMatchVal = val => {
    let error;
    let number = parseFloat(val);
    if (this.state.participantPerMatch && number) {
      if (!is_Natural(number)) {
        error = `Invalid input value`;
      } else if (number < 1) {
        error = `Minimum winner should be 1`;
      } else if (this.state.participantPerMatch <= number) {
        error = `Winner per match should not be more than ${this.state.participantPerMatch - 1}`;
      }
    }
    return error;
  };
  thresholdVal = val => {
    let error;
    let number = parseFloat(val);
    if (
      this.state.participantPerMatch !== this.state.winnerPerMatch &&
      this.state.maxParticipants &&
      this.state.noOfGroup &&
      this.state.participantPerMatch &&
      this.state.winnerPerMatch &&
      val
    ) {
      let participantPerGroup = this.state.maxParticipants / this.state.noOfGroup;
      if (!is_Natural(number)) {
        error = `Invalid input value`;
      } else if (
        ((participantPerGroup / this.state.participantPerMatch) * this.state.winnerPerMatch) %
          this.state.participantPerMatch ===
        0
      ) {
        let possibleThresholds = [];
        let tempResult =
          (participantPerGroup / this.state.participantPerMatch) * this.state.winnerPerMatch;
        while (participantPerGroup % this.state.participantPerMatch === 0) {
          possibleThresholds.push(tempResult * this.state.noOfGroup);
          participantPerGroup =
            (participantPerGroup / this.state.participantPerMatch) * this.state.winnerPerMatch;
          tempResult =
            (participantPerGroup / this.state.participantPerMatch) * this.state.winnerPerMatch;
        }

        let numbers = "";
        possibleThresholds.map((el, i) => {
          if (i + 1 === possibleThresholds.length) {
            numbers = numbers + el;
          } else {
            numbers = numbers + el + ",";
          }
        });
        if (!possibleThresholds.includes(number)) {
          error = `Threshold should be one of ${numbers}.`;
        }
      } else if (
        (participantPerGroup / this.state.participantPerMatch) *
          this.state.winnerPerMatch *
          this.state.noOfGroup !==
        number
      ) {
        error = `Threshold should be ${(participantPerGroup / this.state.participantPerMatch) * this.state.winnerPerMatch * this.state.noOfGroup}`;
      }
    }
    return error;
  };

  showToolTip = (id, place = "top", type = "warning", text) => {
    return (
      <ReactTooltip id={id} place={place} effect="solid" type={type}>
        {text}
      </ReactTooltip>
    );
  };

  render() {
    this.currentStages = this.state.tournamentDetails ? this.state.tournamentDetails.stages : false;
    const isUpdated = this.isUpdate && this.currentStages ? true : false;
    let type = this.state.tournamentDetails?.participantType === "TEAM" ? "Teams" : "Participants";

    const requiredObject = getWebData();

    const initials = {
      stageName: this.state.stageName,
      maxParticipant: this.state.maxParticipants,
      maxNumberOfGroups: this.state.noOfGroup,
      maxParticipantsPerMatch: this.state.participantPerMatch,
      winnersPerMatch: this.state.winnerPerMatch,
      qualificationThreshold: this.state.threshold,
      playoffFormat: this.state.playoffFormat,
    };

    return (
      <section className="body-section ffa-bracket-groups tooltip-text">
        <div className="container p-3 mt-lg-3">
          <TournamentHeader
            tournamentDetails={this.state.tournamentDetails}
            logo={stages}
            heading={`${isUpdated ? "Update" : "Add"} Stage Details`}
            subHeading={<h1 className="stage-sub-heading text-center">( FFA Bracket Groups )</h1>}
            history={this.props.history}
          />

          <Formik
            enableReinitialize
            initialValues={initials}
            validationSchema={Yup.object({
              stageName: Yup.string().required("*Stage name required").max(30, "Max 30 characters"),
              maxParticipant: Yup.number().required("Max participants required"),
              //.oneOf([2,4,8,16,32,64,128,256,512,1024,2048,4096,8192,16384],'Max participants should be in form of 2,4,8,16,32...'),
              qualificationThreshold: Yup.string().required("*Qualification Threshold id required"),
              maxNumberOfGroups: Yup.string().required("*Max no of groups is required"),
              winnersPerMatch: Yup.string().required("*Winner per match is required"),
              maxParticipantsPerMatch: Yup.string().required(
                this.state.tournamentDetails?.participantType === "TEAM"
                  ? "*Teams per match is required"
                  : "*Paticipants per match is required"
              ),
            })}
            onSubmit={(values, { setSubmitting }) => {
              setTimeout(() => {
                this.onSubmit(values);
                setSubmitting(false);
              }, 400);
            }}
          >
            <Form className="row f-bracket-group-form m-1 mt-lg-5" autoComplete="off">
              <div className="col-lg-6 col-md-6 col-12">
                <label htmlFor="stageName" className="fs-14 fw-600 text-white mb-1 mt-2 mt-lg-3">
                  Stage Name
                </label>
                <Field
                  name="stageName"
                  placeholder="Enter Stage Name"
                  type="text"
                  onKeyUp={e => this.updateQuantity(e, "stageName")}
                  className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                />
                <ErrorMessage component="span" className="error-msg" name="stageName" />
              </div>

              <div className="col-lg-6 col-md-6 col-12">
                <label
                  htmlFor="maxParticipant"
                  className="fs-14 fw-600 text-white mb-1 mt-2 mt-lg-3"
                >
                  Max {type}
                </label>

                <a
                  href="#"
                  title="Maximum No. of Participants that can Participate in Tournament or Stage"
                  className="tooltip-info"
                >
                  <BsInfoCircle className="text-white btn-size-12 ms-1 mt-2" />
                </a>
                <Field
                  name="maxParticipant"
                  placeholder="Enter Max Participants"
                  validate={this.maxParticipantVal}
                  onKeyUp={e => this.updateQuantity(e, "maxParticipants")}
                  type="number"
                  className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                  min={1}
                  step={1}
                  onWheel={e => e.target.blur()}
                />
                <ErrorMessage component="span" className="error-msg" name="maxParticipant" />
              </div>

              <div className="col-lg-6 col-md-6 col-12">
                <label
                  htmlFor="maxNumberOfGroups"
                  className="fs-14 fw-600 text-white mb-1 mt-2 mt-lg-3"
                >
                  Number of Groups
                </label>

                <a
                  href="#"
                  title={requiredObject.INFORMATION_TEXT?.STAGE_DETAILS?.MAX_NO_OF_GROUPS}
                  className="tooltip-info"
                >
                  <BsInfoCircle className="text-white btn-size-12 ms-1 mt-2" />
                </a>
                <Field
                  validate={this.noOfGroupVal}
                  onKeyUp={e => this.updateQuantity(e, "noOfGroup")}
                  name="maxNumberOfGroups"
                  type="number"
                  placeholder="Enter Winners Per Match"
                  className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                  min={1}
                  step={1}
                  onWheel={e => e.target.blur()}
                />
                <ErrorMessage component="span" className="error-msg" name="maxNumberOfGroups" />
              </div>

              <div className="col-lg-6 col-md-6 col-12">
                <label
                  htmlFor="maxParticipantsPerMatch"
                  className="fs-14 fw-600 text-white mb-1 mt-2 mt-lg-3"
                >
                  {this.state.tournamentDetails?.participantType === "TEAM"
                    ? LABEL.TEAMS_PER_MATCH
                    : "Participants Per Match"}
                </label>

                <a
                  href="#"
                  title={
                    this.state.tournamentDetails?.participantType === "TEAM"
                      ? "It is Maximum No. of Teams that can participate in a Match."
                      : "It is Maximum No. of Participants that can participate in a Match."
                  }
                  className="tooltip-info"
                >
                  <BsInfoCircle className="text-white btn-size-12 ms-1 mt-2" />
                </a>
                <Field
                  validate={this.participantPerMatchVal}
                  onKeyUp={e => this.updateQuantity(e, "participantPerMatch")}
                  name="maxParticipantsPerMatch"
                  type="number"
                  placeholder={
                    this.state.tournamentDetails?.participantType === "TEAM"
                      ? PLACEHOLDER.TEAMS_PER_MATCH
                      : "Enter Participants Per Match"
                  }
                  className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                  min={1}
                  step={1}
                  onWheel={e => e.target.blur()}
                />
                <ErrorMessage
                  component="span"
                  className="error-msg"
                  name="maxParticipantsPerMatch"
                />
              </div>

              <div className="col-lg-6 col-md-6 col-12">
                <label
                  htmlFor="winnersPerMatch"
                  className="fs-14 fw-600 text-white mb-1 mt-2 mt-lg-3"
                >
                  Winners Per Match
                </label>

                <a
                  href="#"
                  title="It is the No. of winners Per Match that would head to Next Stage."
                  className="tooltip-info"
                >
                  <BsInfoCircle className="text-white btn-size-12 ms-1 mt-2" />
                </a>
                <Field
                  name="winnersPerMatch"
                  validate={this.winnerPerMatchVal}
                  onKeyUp={e => this.updateQuantity(e, "winnerPerMatch")}
                  placeholder="Enter Winners Per Match"
                  type="number"
                  className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                  min={1}
                  step={1}
                  onWheel={e => e.target.blur()}
                />
                <ErrorMessage component="span" className="error-msg" name="winnersPerMatch" />
              </div>

              <div className="col-lg-6 col-md-6 col-12">
                <label
                  htmlFor="qualificationThreshold"
                  className="fs-14 fw-600 text-white mb-1 mt-2 mt-lg-3"
                >
                  Qualification Threshold
                </label>

                <a
                  href="#"
                  title={requiredObject.INFORMATION_TEXT?.STAGE_DETAILS?.QUALIFICATION_THRESHOLD}
                  className="tooltip-info"
                >
                  <BsInfoCircle className="text-white btn-size-12 ms-1 mt-2" />
                </a>
                <Field
                  name="qualificationThreshold"
                  validate={this.thresholdVal}
                  onKeyUp={e => this.updateQuantity(e, "threshold")}
                  type="number"
                  placeholder="Enter Qualification Threshold"
                  className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                  min={1}
                  step={1}
                  onWheel={e => e.target.blur()}
                />
                <ErrorMessage
                  component="span"
                  className="error-msg"
                  name="qualificationThreshold"
                />
              </div>

              <div className="col-lg-6 col-md-6 col-12">
                <label
                  htmlFor="playoffFormat"
                  className="fs-14 fw-600 text-white mb-1 mt-2 mt-lg-3"
                >
                  Playoff Format
                </label>

                <a
                  href="#"
                  title={requiredObject.INFORMATION_TEXT?.STAGE_DETAILS?.PLAY_OFF_FORMAT}
                  className="tooltip-info"
                >
                  <BsInfoCircle className="text-white btn-size-12 ms-1 mt-2" />
                </a>
                <Field
                  value={this.state.playoffFormat}
                  onChange={e => this.updateQuantity(e, "playoffFormat")}
                  name="playoffFormat"
                  as="select"
                  id="playOff"
                  className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                >
                  {Object.keys(PlayoffFormats).map(function (key, i) {
                    return (
                      <option key={i} value={PlayoffFormats[key]}>
                        {key}
                      </option>
                    );
                  })}
                </Field>
                <ErrorMessage component="span" className="error-msg" name="playoffFormat" />
              </div>

              <div className="mt-5 d-flex justify-content-center">
                {isUpdated ? (
                  <div className="d-flex justify-content-center">
                    <div className="d-flex flex-column align-items-center me-6">
                      <button
                        type="submit"
                        className="round-btn rounded-circle d-flex align-items-center justify-content-center border-0 btn-size-45 mx-4"
                      >
                        <AiOutlineCheck className="fs-24" />
                      </button>
                      <span className="fw-bold text-white mt-2">Save Changes</span>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <button
                        type="button"
                        onClick={e => this.onClickOpenConfirm(e)}
                        className="round-btn rounded-circle d-flex align-items-center justify-content-center border-0  btn-size-45 mx-4"
                      >
                        <AiFillDelete className="fs-24" />
                      </button>
                      <span className="fw-bold text-white mt-2">Delete Structure</span>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex flex-column align-items-center">
                    <button
                      type="submit"
                      className="round-btn rounded-circle d-flex align-items-center justify-content-center border-0 btn-size-45"
                    >
                      <FiPlus className="fs-24" />
                    </button>
                    <span className="fw-bold text-white mt-2">Save Structure</span>
                  </div>
                )}
              </div>
            </Form>
          </Formik>
        </div>
        <Modal
          show={this.state.openConfirmationModal}
          centered
          dialogClassName="Confirmation-modal"
        >
          <Modal.Body>
            <ConfirmationModal
              onClickOpenConfirm={this.onClickOpenConfirm}
              confirmed={this.deleteStage}
              confirm={{
                msg:
                  parseInt(this.index) ===
                  parseInt(this.state.tournamentDetails?.stages.length - 1) ? (
                    <p className="fs-14 fw-600 text-center text-white-50">
                      Are you sure you want to remove{" "}
                      <span className="error-msg">
                        {isUpdated ? this.currentStages[this.index]?.name : ""}
                      </span>{" "}
                      from the stages ?
                    </p>
                  ) : (
                    <p className="fs-14 fw-600 text-center text-white-50">
                      Next stages will be deleted on delete of{" "}
                      <span className="error-msg">
                        {isUpdated ? this.currentStages[this.index]?.name : ""}
                      </span>{" "}
                      stage. Are you sure you want to edit this stage?
                    </p>
                  ),
                key: isUpdated ? this.index : null,
              }}
            />
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.openEditConfirmationModal}
          centered
          dialogClassName="Confirmation-modal"
        >
          <Modal.Body>
            <ConfirmationModal
              confirm={{
                msg: (
                  <p className="fs-14 fw-600 text-center text-white-50">
                    {WARNING.NEXT_STAGE_WILL_BE_DELETED}
                  </p>
                ),
                key: isUpdated ? this.index : null,
              }}
              onClickOpenConfirm={() => {
                this.setState({ openEditConfirmationModal: false });
              }}
              confirmed={() => {
                this.addOrUpdate(this.editStages, this.editIsUpdate);
              }}
            />
          </Modal.Body>
        </Modal>
      </section>
    );
  }
}
